import type { RevalidationItem } from './revalidationList.types'

const SEP = '\u001E'

export function revalidationListItemKey(item: RevalidationItem): string {
  return [item.project_name ?? '', item.reference_inverter_brand ?? ''].join(SEP)
}
